// This file is generated by scripts/prepublish.mjs
// Do not edit this file directly
module.exports = require('../../static/microbit/scratch-microbit.hex');
